import request from '@/utils/request'
// 获取传入类型和父级编号的下级数据
export const getNextLevelData = (data) => {
    return request.get('/api/sysTreeDict/nextLevelData', data)
}
// 获取临时文件URL
export const getTempFileUrl = (fileId) => {
    return request.get(`/api/file/tmp/url/${fileId}`)
}
//根据fileBindId获取文件列表
export const getFileList = (fileBindId) => {
    return request.get('/api/file/list?fileBindId='+fileBindId)
}
// 通过fileGuid 获取文件下载列表
export const getFileDownloadList = (fileGuid) => {
    return request.get('/api/file/info?fileId='+fileGuid)
}
//根据项目编号 - 获取标段信息
export const getSectionInfoByProjectCode = (projectCode) => {
    return request.get('/api/common/section/info?projectCode='+projectCode)
}

//根据标段编号获取文件信息
export const getInfoBySectionCode = (sectionCode) => {
    return request.get('/api/agent/bidInvitationDocuments/getInfoBySectionCode?sectionCode='+sectionCode)
}
// 监听消息通知topic
export const getMsgTopic = (channelCode) => {
    return request.get('/api/common/msg/topic?channelCode='+channelCode)
}

// 通知消息列表
export const getMsgList = (params) => {
    return request.get('/api/common/index/msg/list', params)
}

// 消息通知详细列表
export const getMsgDetailList = (params) => {
    return request.get('/api/common/msg/list', params)
}



